





















import { mixins } from 'vue-class-component'
import { Component } from 'vue-property-decorator'

import DisalableBookingElementMixin from '@/components/DisalableBookingElementMixin.vue'

@Component
export default class BookingPassengersAndPayments extends mixins(
  DisalableBookingElementMixin,
) {}
